/* Название поездки в полосе инструментов. Кнопка притворяется текстом: это
   заголовок, который можно поправить, а не действие — рамка появляется только
   под курсором и по фокусу с клавиатуры. */
.name,
.readonly {
  display: block;
  max-width: 22ch;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: var(--fs-md);
  font-weight: 600;
  line-height: var(--ctl-h);
  color: var(--text);
}

.name {
  padding: 0 var(--sp-2);
  border: var(--bw) solid transparent;
  border-radius: var(--radius);
  background: none;
  font-family: inherit;
  text-align: left;
  cursor: text;
}

.name:hover {
  border-color: var(--border);
  background: var(--surface);
}

.name:focus-visible {
  outline: none;
  border-color: var(--border);
  box-shadow: var(--focus-ring);
}

/* Соавтору название только показывают: приглушённый цвет говорит это раньше,
   чем он попробует нажать. */
.readonly {
  padding: 0 var(--sp-2);
  color: var(--text-2);
  cursor: default;
}

.input {
  width: 22ch;
  height: var(--ctl-h);
}

/* В бургер-меню поле забирает остаток строки, а не всю её ширину: с width:100%
   оно выжимало подпись слева и та переносилась на две строки. Обрезать его при
   этом незачем — с контролами полосы оно там не соседствует. */
@media (max-width: 720px) {
  .name,
  .readonly,
  .input {
    max-width: none;
    width: auto;
    flex: 1 1 auto;
    min-width: 0;
  }
}
